export const GET_INTERNSHIP_SERVICES = "GET_INTERNSHIP_SERVICES"
export const GET_INTERNSHIP_SERVICES_FAIL = "GET_INTERNSHIP_SERVICES_FAIL"
export const GET_INTERNSHIP_SERVICES_SUCCESS = "GET_INTERNSHIP_SERVICES_SUCCESS"

export const ADD_NEW_INTERNSHIP_SERVICE = "ADD_NEW_INTERNSHIP_SERVICE"
export const ADD_INTERNSHIP_SERVICE_SUCCESS = "ADD_INTERNSHIP_SERVICE_SUCCESS"
export const ADD_INTERNSHIP_SERVICE_FAIL = "ADD_INTERNSHIP_SERVICE_FAIL"

export const UPDATE_INTERNSHIP_SERVICE = "UPDATE_INTERNSHIP_SERVICE"
export const UPDATE_INTERNSHIP_SERVICE_SUCCESS = "UPDATE_INTERNSHIP_SERVICE_SUCCESS"
export const UPDATE_INTERNSHIP_SERVICE_FAIL = "UPDATE_INTERNSHIP_SERVICE_FAIL"

export const DELETE_INTERNSHIP_SERVICE = "DELETE_INTERNSHIP_SERVICE"
export const DELETE_INTERNSHIP_SERVICE_SUCCESS = "DELETE_INTERNSHIP_SERVICE_SUCCESS"
export const DELETE_INTERNSHIP_SERVICE_FAIL = "DELETE_INTERNSHIP_SERVICE_FAIL"





